import { AppPermissionService } from '../../core/services/app-permission.service';
import { GbgrundstueckService } from '../../core/gb-api';
import { Component, Input, OnInit } from '@angular/core';
import { TimepointService } from '../../core/services/timepoint.service';
import { FormatConfigService } from '../../core/services/format-config.service';
import { AppConfigService } from '../../core/services/app-config.service';
import { ActivatedRoute } from '@angular/router';
import { AbstractGrundstueckEntryFromInputComponent } from '../grundstueck-rubriken/abstract-grundstueck-entry-from-input.component';
import { CapSpinnerSmallComponent } from '../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { AmtlicheVermessungComponent } from './amtliche-vermessung/amtliche-vermessung.component';
import { GrundbuchComponent } from './grundbuch/grundbuch.component';
import { AmtlicheBewertungComponent } from './amtliche-bewertung/amtliche-bewertung.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundstueck-beschreibung',
  templateUrl: './grundstueck-beschreibung.component.html',
  styleUrls: ['./grundstueck-beschreibung.component.scss'],
  imports: [CapSpinnerSmallComponent, AmtlicheVermessungComponent, GrundbuchComponent, AmtlicheBewertungComponent, TranslatePipe]
})
export class GrundstueckBeschreibungComponent extends AbstractGrundstueckEntryFromInputComponent implements OnInit {
  parameterAmtlicheBewertung: boolean;

  _hasRight = true;

  showSpinner = true;

  constructor(
    protected route: ActivatedRoute,
    protected gsService: GbgrundstueckService,
    protected timepointService: TimepointService,
    protected permissionService: AppPermissionService,
    protected appConfigService: AppConfigService,
    protected appformatConfigService: FormatConfigService
  ) {
    super(route, gsService, timepointService, appConfigService);
  }

  ngOnInit() {
    this.addSub(
      this.appformatConfigService.parameterConfig$.subscribe((config) => {
        this.parameterAmtlicheBewertung = <any>config?.parameters.AMTLICHE_BEWERTUNG_FUEHREN;
      })
    );
  }

  @Input()
  set hasRight(value: boolean) {
    if (value === null || value === undefined) {
      return;
    }
    this.showSpinner = false;
    this._hasRight = value;
  }
}
